export default __webpack_public_path__ + "static/media/drawforththeheart.85affa08.png";